import React, { FC, SyntheticEvent } from 'react';
import classNames from 'classnames';
import { closeActiveTooltip } from '../../TooltipBtn';
import classes from '../styles/index.module.scss';
import { ThemeStyle } from '../../../utils/const';

type OverlayTooltipProps = {
	theme?: ThemeStyle;
	autoClose?: boolean;
	stopPropagation?: boolean;
	className?: string;
};

export const OverlayTooltip: FC<React.PropsWithChildren<OverlayTooltipProps>> = ({
	theme = ThemeStyle.Light,
	autoClose,
	stopPropagation,
	className,
	children,
}) => {
	const Children = children;
	const componentClasses = classNames(
		classes.tooltip,
		{
			[classes.tooltip_darkTheme]: theme === ThemeStyle.Dark,
			[classes.tooltip_lightTheme]: theme === ThemeStyle.Light,
		},
		className,
	);

	const handleComponentClick = (e: SyntheticEvent) => {
		if (autoClose) {
			closeActiveTooltip();
		}

		if (stopPropagation) {
			e.stopPropagation();
		}
	};

	return (
		<div
			className={componentClasses}
			data-testid='overlayTooltip'
			onClick={handleComponentClick}
		>
			<div className={classes.tooltip__content}>
				{React.isValidElement(children) ? (
					children
				) : (
					// @ts-ignore
					<Children />
				)}
			</div>
		</div>
	);
};
